"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _Heading = _interopRequireDefault(require("../../../text/Heading5"));

var _Heading2 = _interopRequireDefault(require("../../../text/Heading6"));

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CommentContainer = _styledComponents["default"].div.withConfig({
  componentId: "h0v1vh-0"
})(["display:flex;flex-direction:column;padding:", "px;background-color:", ";"], (0, _themeGet.themeGet)('space.2'), function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.backgroundColor || 'transparent')(props);
});

var Comment = (0, _react.memo)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      title = _ref.title,
      subTitle = _ref.subTitle,
      text = _ref.text,
      maxCharactersBeforeTruncation = _ref.maxCharactersBeforeTruncation;
  return _react["default"].createElement(CommentContainer, {
    backgroundColor: backgroundColor
  }, _react["default"].createElement(_Heading["default"], {
    mb: 1,
    fontSize: 2
  }, title), _react["default"].createElement(_Heading2["default"], {
    subdued: true,
    mb: 2
  }, subTitle), _react["default"].createElement(_Body["default"], {
    fontSize: 0,
    characterLimit: maxCharactersBeforeTruncation
  }, text));
});
Comment.displayName = 'Comment';
Comment.propTypes = {
  backgroundColor: _propTypes["default"].string,
  title: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  text: _propTypes["default"].node,
  maxCharactersBeforeTruncation: _propTypes["default"].number
};
var _default = Comment;
exports["default"] = _default;